import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import clsx from 'clsx';

import styles from '@/components/ImageCard/ImageCard.module.css';
import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

export interface ImageCardProps {
  imageURL: string;
  imageAltText?: string;
  description?: string;
}

export const ImageCard = ({ imageURL, imageAltText, description }: ImageCardProps) => {
  const wrapperClasses = clsx(styles.wrapper);
  const imageClasses = clsx(styles.image, {
    [styles['image--no-description'] as string]: !description,
  });
  const contentClasses = clsx(styles.content);
  const descriptionClasses = clsx(styles.description);

  return (
    <div className={wrapperClasses}>
      <img
        className={imageClasses}
        style={{ objectFit: 'cover' }}
        alt={imageAltText || description || 'Image'}
        src={
          getCDNURL(imageURL, 640, 335) || `${getCDNURL(PICKLEBALL_PLACEHOLDER_IMAGE, 640, 640)}`
        }
      />
      {description ? (
        <div className={contentClasses}>
          <h3 className={descriptionClasses}>{description}</h3>
        </div>
      ) : null}
    </div>
  );
};
